module.exports = __webpack_public_path__ + "static/media/bg_recintes.96f89dbb.png";